export const ADMIN_PACKAGES_DASHBOARD = '/admin/:companyCode/dashboard'
export const FORGOT_PASSWORD = '/forgot-password'
export const TENANT_REGISTRATION = '/:companyCode/register'
export const TENANT_PACKAGE = '/tenant/:companyCode/:buildingCode/package'
export const TENANT_PACKAGE_PURCHASES = '/tenant/:companyCode/:buildingCode/package/my-purchases'
export const TENANT_CREATE_BOOKING = '/tenant/:companyCode/:buildingCode/booking/create'
